import Helpers from './../helpers/utility';
var isObject = Helpers.isObject;
var StringHelpers;
(function (StringHelpers) {
    /**
      * helper for format methods: parses arguments into a named map, e.g. an object,
      * or a regular (ordinal) map, e.g. an array
      *
      * @param {any} target The
      * @param {any} arg1
      * @returns
      */
    function getFormatData(target, arg1) {
        var namedMap = isObject(arg1) && arguments.length === 2;
        return {
            namedMap: namedMap,
            map: namedMap ?
                arg1 :
                Array.prototype.slice.call(arguments, 1)
        };
    }
    StringHelpers.getFormatData = getFormatData;
    function formatDynamic(target, fn) {
        var index = 0;
        return (target || '').replace(StringHelpers.pattern, function (match, parm) {
            return fn(parm, index++);
        });
    }
    StringHelpers.pattern = /\{([a-zA-Z0-9]+)\}/g;
})(StringHelpers || (StringHelpers = {}));
export default StringHelpers;
//# sourceMappingURL=helpers.js.map